import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import useInterfaceSounds from '../../utils/filemanager/useInterfaceSounds';
import audioManager from '../../utils/filemanager/AudioManager';
import ReferralDashboard from '../account/ReferralDashboard';
import { useSearchParams } from 'react-router-dom';

const Dashboard = ({ onHarvesterClick, onReferralNetworkClick, onFragmentRedemptionClick }) => {
  const [searchParams] = useSearchParams();
  const [showReferralDashboard, setShowReferralDashboard] = useState(false);
  const [harvesterEnabled, setHarvesterEnabled] = useState(false);
  const [mapEnabled, setMapEnabled] = useState(false);
  const [fragmentEnabled, setFragmentEnabled] = useState(false);

  // Initialize interface sounds
  useInterfaceSounds();

  // Check if modules are enabled
  useEffect(() => {
    const checkModules = async () => {
      try {
        const apiUrl = process.env.REACT_APP_FIREBASE_API_URL;
        if (!apiUrl) {
          console.error('API URL not configured');
          return;
        }

        // Check harvester module
        const harvesterResponse = await fetch(`${apiUrl}/neuranet/modules/harvester.json`);
        if (harvesterResponse.ok) {
          const harvesterStatus = await harvesterResponse.json();
          console.log('Harvester module enabled:', harvesterStatus);
          setHarvesterEnabled(harvesterStatus === true);
        }

        // Check map module
        const mapResponse = await fetch(`${apiUrl}/neuranet/modules/map.json`);
        if (mapResponse.ok) {
          const mapStatus = await mapResponse.json();
          console.log('Map module enabled:', mapStatus);
          setMapEnabled(mapStatus === true);
        }

        // Check fragment module
        const fragmentResponse = await fetch(`${apiUrl}/neuranet/modules/fragment.json`);
        if (fragmentResponse.ok) {
          const fragmentStatus = await fragmentResponse.json();
          console.log('Fragment module enabled:', fragmentStatus);
          setFragmentEnabled(fragmentStatus === true);
        }
      } catch (error) {
        console.error('Error checking modules:', error);
      }
    };
    checkModules();
  }, []);

  // Handle referral code from URL
  useEffect(() => {
    const referralCode = searchParams.get('ref');
    if (referralCode) {
      // Store referral code in localStorage to use after Discord auth
      localStorage.setItem('pending_referral', referralCode);
    }
  }, [searchParams]);

  const handleHarvesterClick = async () => {
    await audioManager.playSuccess();
    onHarvesterClick();
  };

  const handleLockedClick = (index) => {
    audioManager.playFail();
  };

  return (
    <div className="dashboard-container">
      {showReferralDashboard && (
        <ReferralDashboard onClose={() => {
          setShowReferralDashboard(false);
          audioManager.playSelect();
        }} />
      )}

      {/* Main Dashboard Content */}
      <div className="dashboard-header">
        NEURANET.BACKDOOR_ENTRYPOINT
      </div>

      <div className="dashboard-grid">
        {harvesterEnabled ? (
          <div
            className="grid-item unlocked"
            onClick={handleHarvesterClick}
            role="button"
          >
            <div className="grid-item-icon">△</div>
            <div className="grid-item-title">Harvester</div>
          </div>
        ) : (
          <div
            className="grid-item locked"
            onClick={() => handleLockedClick(0)}
            role="button"
          >
            <div className="grid-item-icon">🔒</div>
          </div>
        )}
        {mapEnabled ? (
          <div
            className="grid-item unlocked"
            onClick={() => {
              audioManager.playSuccess();
              onReferralNetworkClick();
            }}
            role="button"
          >
            <div className="grid-item-icon">⊕</div>
            <div className="grid-item-title">ORBITAL MAP</div>
          </div>
        ) : (
          <div
            className="grid-item locked"
            onClick={() => handleLockedClick(1)}
            role="button"
          >
            <div className="grid-item-icon">🔒</div>
          </div>
        )}
        {fragmentEnabled ? (
          <div
            className="grid-item unlocked"
            onClick={() => {
              audioManager.playSuccess();
              onFragmentRedemptionClick();
            }}
            role="button"
          >
            <div className="grid-item-icon">◆</div>
            <div className="grid-item-title">DEFRAGGER</div>
          </div>
        ) : (
          <div
            className="grid-item locked"
            onClick={() => handleLockedClick(2)}
            role="button"
          >
            <div className="grid-item-icon">🔒</div>
          </div>
        )}
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="grid-item locked"
            onClick={() => handleLockedClick(index + 3)}
            role="button"
          >
            <div className="grid-item-icon">🔒</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;